export const selectDiagnostic = state => state.diagnostic;
